/* eslint-disable @next/next/no-img-element */
import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import SectionLine from "@/common/components/_UI/SectionLine"

import WalletAPP from "@/common/assets/image/products/icons/WalletApp.svg"
import AppStoreWhiteImage from "@/common/assets/image/button/AppDownloadAppStoreWhite.svg"
import GooglePlayWhiteImage from "@/common/assets/image/button/AppDownloadGooglePlayWhite.svg"
import SafetyImage1 from "@/common/assets/image/products/wallet/application/Safety1.webp"
import SafetyImage2 from "@/common/assets/image/products/wallet/application/Safety2.webp"
import SafetyImage3 from "@/common/assets/image/products/wallet/application/Safety3.webp"
import SafetyImage4 from "@/common/assets/image/products/wallet/application/Safety4.webp"
import UXImage1 from "@/common/assets/image/products/wallet/application/UX1.webp"
import UXImage2 from "@/common/assets/image/products/wallet/application/UX2.webp"
import UXImage3 from "@/common/assets/image/products/wallet/application/UX3.webp"
import UXImage4 from "@/common/assets/image/products/wallet/application/UX4.webp"
import UXImage5 from "@/common/assets/image/products/wallet/application/UX5.webp"
import SocializeImage1 from "@/common/assets/image/products/wallet/application/Socialize1.webp"
import SocializeImage2 from "@/common/assets/image/products/wallet/application/Socialize2.webp"

import BTC from "@/common/assets/image/chainIcon/BTC.svg"
import ETH from "@/common/assets/image/chainIcon/ETH.svg"
import BNB from "@/common/assets/image/chainIcon/BSC.svg"
import Polygon from "@/common/assets/image/chainIcon/Polygon.svg"
import Solana from "@/common/assets/image/chainIcon/Solana.svg"
import TRON from "@/common/assets/image/chainIcon/TRON.svg"
import KCC from "@/common/assets/image/chainIcon/KCC.svg"
import ARB from "@/common/assets/image/chainIcon/ARB.svg"
import Ronin from "@/common/assets/image/chainIcon/Ronin.svg"
import Oasys from "@/common/assets/image/chainIcon/Oasys.svg"

import Chloe from "@/common/assets/image/products/wallet/application/Chloe.svg"
import Estelle from "@/common/assets/image/products/wallet/application/Estelle.svg"
import Olivia from "@/common/assets/image/products/wallet/application/Olivia.svg"

import AppStore from "@/common/assets/image/button/AppDownloadAppStore.svg"
import GooglePlay from "@/common/assets/image/button/AppDownloadGooglePlay.svg"
import DownloadAppImage from "@/common/assets/image/products/wallet/application/DownloadApp.webp"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import TrustedBy from "@/common/components/TrustedBy"
import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import Description from "@/common/components/Description"
import ProductViewMore from "@/common/components/ProductViewMore"
import { ProductBanner } from "@/common/components/ProductBanner"
import { ProductNames, SolutionNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"
import styled, { useTheme } from "styled-components"
import { theme } from "@/common/Mixin"
import NextImg from "@/common/components/NextImg"
import { useMediaQuery } from "@mui/material"
import ImageButton from "@/common/components/ImageButton"
import Card from "@/common/components/ProductCard/Card"
import { CustomerCardList } from "@/common/components/SuccessStory"
import { ReactNode } from "react"

const WalletApplicationPage = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(`(${theme.lg})`)
  const { t } = useTranslation(["walletApplication"])
  const { t: commonT } = useTranslation(["common"])

  // const appStoreUrl = "https://apps.apple.com/app/kryptogo/id1593830910"
  const appStoreUrl = t("Banner.appStoreUrl")
  const googlePlayUrl =
    "https://play.google.com/store/apps/details?id=com.kryptogo.walletapp"

  const userTestimonialData = [
    {
      company: t("UserTestimonials.1.title"),
      name: t("UserTestimonials.1.name"),
      description: t("UserTestimonials.1.desc"),
      image: Olivia
    },
    {
      company: t("UserTestimonials.2.title"),
      name: t("UserTestimonials.2.name"),
      description: t("UserTestimonials.2.desc"),
      image: Estelle
    },
    {
      company: t("UserTestimonials.3.title"),
      name: t("UserTestimonials.3.name"),
      description: t("UserTestimonials.3.desc"),
      image: Chloe
    }
  ]

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products/wallet"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products/wallet"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products/wallet"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products/wallet"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          icon={WalletAPP.src}
          bannerType={ProductNames.WalletApplication}
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          body={t("Banner.subtitle")}
          description={t("Banner.description")}
          buttonList={[
            {
              element: (
                <ImageButton
                  image={AppStoreWhiteImage.src}
                  href={appStoreUrl}
                />
              )
            },
            {
              element: (
                <ImageButton
                  image={GooglePlayWhiteImage.src}
                  href={googlePlayUrl}
                />
              )
            },
            {
              element: (
                <a
                  href="https://www.producthunt.com/posts/kryptogo-wallet?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-kryptogo-wallet"
                  target="_blank"
                >
                  <img
                    src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=425695&theme=neutral"
                    alt="KryptoGO Wallet - Highly secure and friendly crypto wallet for web3. | Product Hunt"
                  />
                </a>
              )
            }
          ]}
        />
        <SectionLine />
        <div
          style={{ display: "flex", flexDirection: "column", gap: "60px" }}
          id="wallet-safety"
        >
          <Description
            backgroundType="none"
            items={[
              {
                wide: true,
                titles: [
                  {
                    text: t("Safety.title"),
                    textClass: "primary title h4"
                  },
                  { text: t("Safety.subtitle"), textType: "h3" },
                  { text: t("Safety.description"), textClass: "body disabled" }
                ]
              }
            ]}
          />
          <div
            id="wallet-safety-cards"
            className="kg-wrapper"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "32px",
              position: "relative"
            }}
          >
            <CardRow>
              <Card
                backgroundType="darkLinear"
                slogan={t("Safety.card.1.slogan")}
                description={t("Safety.card.1.desc")}
                image={SafetyImage1}
              />
              <Card
                backgroundType="lightLinear"
                slogan={t("Safety.card.2.slogan")}
                description={t("Safety.card.2.desc")}
                image={SafetyImage2}
              />
            </CardRow>
            <CardRow>
              <Card
                backgroundType="lightLinear"
                slogan={t("Safety.card.3.slogan")}
                description={t("Safety.card.3.desc")}
                image={SafetyImage3}
              />
              <Card
                backgroundType="darkLinear"
                slogan={t("Safety.card.4.slogan")}
                description={t("Safety.card.4.desc")}
                image={SafetyImage4}
              />
            </CardRow>
          </div>
        </div>
        <SectionLine />

        <div
          style={{ display: "flex", flexDirection: "column", gap: "60px" }}
          id="ux-section"
        >
          <Description
            backgroundType="none"
            items={[
              {
                wide: true,
                titles: [
                  {
                    text: t("UX.title"),
                    textClass: "primary title h4"
                  },
                  { text: t("UX.subtitle"), textType: "h3" },
                  { text: t("UX.description"), textClass: "body disabled" }
                ]
              }
            ]}
          />
          <div
            id="ux-cards"
            className="kg-wrapper"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "32px",
              position: "relative"
            }}
          >
            <CardRow>
              <Card
                backgroundType="darkLinear"
                slogan={t("UX.card.1.slogan")}
                description={t("UX.card.1.desc")}
                image={UXImage1}
              />
              <Card
                backgroundType="lightLinear"
                slogan={t("UX.card.2.slogan")}
                description={t("UX.card.2.desc")}
                image={UXImage2}
              />
            </CardRow>
            <Card
              wide
              backgroundType="dark"
              slogan={t("UX.card.3.slogan")}
              description={t("UX.card.3.desc")}
              additionalElements={[
                <NextImg src={BTC.src} key="BTC" style={{ width: "unset" }} />,
                <NextImg src={ETH.src} key="ETH" style={{ width: "unset" }} />,
                <NextImg
                  src={Polygon.src}
                  key="Polygon"
                  style={{ width: "unset" }}
                />,
                <NextImg
                  src={Solana.src}
                  key="Solana"
                  style={{ width: "unset" }}
                />,
                <NextImg src={BNB.src} key="BNB" style={{ width: "unset" }} />,
                <NextImg
                  src={TRON.src}
                  key="TRON"
                  style={{ width: "unset" }}
                />,
                <NextImg src={ARB.src} key="ARB" style={{ width: "unset" }} />,
                <NextImg src={KCC.src} key="KCC" style={{ width: "unset" }} />,
                <NextImg
                  src={Ronin.src}
                  key="Ronin"
                  style={{ width: "unset" }}
                />,
                <NextImg
                  src={Oasys.src}
                  key="Oasys"
                  style={{ width: "unset" }}
                />
              ]}
              image={UXImage3}
            />
            <CardRow>
              <Card
                backgroundType="lightLinear"
                slogan={t("UX.card.4.slogan")}
                description={t("UX.card.4.desc")}
                image={UXImage4}
              />
              <Card
                backgroundType="darkLinear"
                slogan={t("UX.card.5.slogan")}
                description={t("UX.card.5.desc")}
                image={UXImage5}
              />
            </CardRow>
          </div>
        </div>
        <SectionLine />
        <div
          style={{ display: "flex", flexDirection: "column", gap: "60px" }}
          id="ux-section"
        >
          <Description
            backgroundType="none"
            items={[
              {
                wide: true,
                titles: [
                  {
                    text: t("Socialize.title"),
                    textClass: "primary title h4"
                  },
                  { text: t("Socialize.subtitle"), textType: "h3" },
                  {
                    text: t("Socialize.description"),
                    textClass: "body disabled"
                  }
                ]
              }
            ]}
          />
          <div
            id="socialize-cards"
            className="kg-wrapper"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "32px",
              position: "relative"
            }}
          >
            <Card
              wide
              backgroundType="lightLinear"
              slogan={t("Socialize.card.1.slogan")}
              description={t("Socialize.card.1.desc")}
              image={SocializeImage1}
            />
            <Card
              wide
              backgroundType="darkLinear"
              slogan={t("Socialize.card.2.slogan")}
              description={t("Socialize.card.2.desc")}
              image={SocializeImage2}
            />
          </div>
        </div>
        <SectionLine />
        <UserRecommendSection
          titleText={t("UserTestimonials.title")}
          subtitleText={t("UserTestimonials.subtitle")}
          UserTestimonialData={userTestimonialData}
        />
        <SectionLine />
        <Description
          backgroundType="none"
          items={[
            {
              wide: true,
              titles: [
                {
                  text: t("DownloadApp.title"),
                  textClass: "primary title h4"
                },
                { text: t("DownloadApp.subtitle"), textType: "h3" },
                {
                  text: t("DownloadApp.description"),
                  textClass: "body disabled"
                }
              ]
            }
          ]}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "24px",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <ImageButton image={GooglePlay.src} href={googlePlayUrl} />
          <ImageButton image={AppStore.src} href={appStoreUrl} />
        </div>
        <NextImg
          id="kryptogo-wallet-image"
          src={DownloadAppImage}
          alt="Studio Image"
        />
        <TrustedBy title={t("partners.title")} />
        <ProductViewMore
          commonT={commonT}
          title={commonT("ViewMore.title")}
          tab={[
            {
              name: commonT("ViewMore.products"),
              content: [
                ProductNames.WalletBuilder,
                ProductNames.WalletExtension,
                ProductNames.WalletAPI
              ]
            },
            {
              name: commonT("ViewMore.solutions"),
              content: [SolutionNames.GameFi, SolutionNames.Defi]
            }
          ]}
          actionText={commonT("ViewMore.allProducts")}
        ></ProductViewMore>
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "walletApplication"
    ]))
  }
})

export default WalletApplicationPage

export const UserRecommendSection = ({
  UserTestimonialData,
  titleText,
  subtitleText,
  children
}: {
  UserTestimonialData: {
    company: string
    name: string
    description: string
    image: any
  }[]
  titleText: string
  subtitleText: string
  children?: ReactNode
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(`(${theme.lg})`)
  return (
    <UserTestimonialWrapper id="UserTestimonials">
      <Description
        backgroundType="none"
        items={[
          {
            wide: true,
            titles: [
              {
                text: titleText,
                textClass: "primary title h4"
              },
              { text: subtitleText, textType: "h3" }
            ]
          }
        ]}
      />
      <UserTestimonialCardsWrapper className="kg-wrapper">
        {isMobile ? (
          <CustomerCardList
            infiniteScroll={false}
            animation={false}
            items={UserTestimonialData}
          />
        ) : (
          <>
            <CustomerCardList
              infiniteScroll={false}
              animation={false}
              style={{ width: "33%" }}
              cardStyle={{ height: "100%" }}
              items={UserTestimonialData.slice(0, 1)}
            />
            <CustomerCardList
              infiniteScroll={false}
              animation={false}
              style={{ width: "33%" }}
              cardStyle={{ height: "100%" }}
              items={UserTestimonialData.slice(1, 2)}
            />
            <CustomerCardList
              infiniteScroll={false}
              animation={false}
              style={{ width: "33%" }}
              cardStyle={{ height: "100%" }}
              items={UserTestimonialData.slice(2, 3)}
            />
          </>
        )}
      </UserTestimonialCardsWrapper>
      {children}
    </UserTestimonialWrapper>
  )
}

const UserTestimonialCardsWrapper = styled.div`
  position: relative;
  margin-top: 3vh;
  display: flex;
  width: 100%;
  gap: 48px;
  overflow: hidden;

  @media (${theme.lg}) {
    max-height: 50vh;
    overflow-y: auto;
    height: auto;
    flex-direction: column;
  }
`

const CardRow = styled.div`
  display: flex;
  gap: 42px;

  @media (${theme.lg}) {
    flex-direction: column;
  }
`

const UserTestimonialWrapper = styled.div`
  display: flex;
  padding-top: 10vh;
  padding-bottom: 10vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 60px;
  background: radial-gradient(
    49.77% 49.75% at 50.05% 50.25%,
    rgba(255, 194, 17, 0.3) 0%,
    rgba(255, 194, 17, 0) 100%
  );
  background-size: 50% 100%;
  background-repeat: no-repeat;
  background-position: center;

  @media (${theme.lg}) {
    background-size: 100% 100%;
  }
`
